import React, { useState,useEffect } from "react";
import {RouteChanged,ROUTE_EXAM_RULES_PAGE, ROUTE_EXAM_REPORT } from '../../RouteConstents';
import { Link, useNavigate } from "react-router-dom";

const TestBlock = ({item}) => {

    const navigate = useNavigate();

    const ExamStartNow = async (examString) => {
        let newURL = RouteChanged(ROUTE_EXAM_RULES_PAGE,examString)
        navigate(newURL);
    } 

    const ExamReport = async (examString) => {
        let newURL = RouteChanged(ROUTE_EXAM_REPORT,examString)
        navigate(newURL);
    } 

    

    

    return (
        <>
        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 app_test_series">
            <div className="card">
                <div className="header">
                    <h2>{item.test_series_title}</h2>
                </div>
                <div className="body">
                    <span><i class="material-icons">list</i>
                        <span className="label_attr"><b>{item.total_questions}</b></span> Questions
                    </span> 
                    <span><i class="material-icons">playlist_add_check</i> 
                        <span className="label_attr"><b>{item.total_marks}</b></span> Marks
                    </span>
                    <span><i class="material-icons">access_alarm</i> 
                        <span className="label_attr"><b>{item.total_time}</b></span> Minutes
                    </span>
                </div>
                <div className="footer">
                {
                    (item.is_test_completed) ? (
                        <>
                            <button type="button" className="btn btn-default waves-effect mr-5 report_btn" onClick={() => ExamReport(item.test_series_id)}>Check Report</button>
                        </>
                    ) : (
                        <>
                            
                        </>  
                    )
                }

                {
                    (item.is_locked) ? (
                        <>
                            <button type="button" className="btn bg-indigo waves-effect disabled" > <i class="material-icons">lock</i> Start Now</button>
                        </>
                    ) : (
                        <>
                            <button type="button" className="btn bg-indigo waves-effect" onClick={() => ExamStartNow(item.test_series_id)}>Start Now</button>
                        </>  
                    )
                } 
                    
                </div>
            </div>
        </div> 
        </>
    );    
};

export default TestBlock;